import React from 'react'
import { Input, TextFieldProps } from '@mui/material'
import { TextFieldAcceptingProps } from './FormTextField'
import { ChampDansFormulaire } from './types/typePourChampDansFormulaireModel'
import { FieldErrors, useFormContext, UseFormRegisterReturn, get } from 'react-hook-form'
import { fontFamilyMonserrat, gecinaErrorColor, WHITE } from '../../theme'
import ErrorComponent from './ErrorComponent'

interface AcceptingProps {
	errorWhite?: boolean,
	fromDatePicker?: boolean
}

type CustomTextFieldProps = ChampDansFormulaire & TextFieldAcceptingProps & TextFieldProps & AcceptingProps

export const CUSTOM_TEXT_FIELD_STYLE = (register: UseFormRegisterReturn, errors: FieldErrors) => ({
	width: '100%',
	mt: '5px',
	marginBottom: '10px',
	backgroundColor: WHITE,
	padding: '0 7px',

	'& .MuiSelect-select': {
		fontFamily: fontFamilyMonserrat,
		fontSize: 15,
		fontWeight: 500
	},
	'input': {
		fontFamily: fontFamilyMonserrat,
		fontSize: 15,
		fontWeight: 500
	},
	'input::-webkit-input-placeholder': {
		fontSize: 13,
		fontWeight: 500,
		fontFamily: fontFamilyMonserrat,
		lineHeight: '20px'
	},
	'input::-moz-placeholder': {
		fontSize: 13,
		fontWeight: 500,
		fontFamily: fontFamilyMonserrat,
		lineHeight: '20px'
	},
	'input:moz-placeholder': {
		fontSize: 13,
		fontWeight: 500,
		fontFamily: fontFamilyMonserrat,
		lineHeight: '20px'
	},
	'input:-ms-input-placeholder': {
		fontSize: 13,
		fontWeight: 500,
		fontFamily: fontFamilyMonserrat,
		lineHeight: '20px'
	},
	':before': {
		borderColor: `${register.name in errors ? gecinaErrorColor : WHITE}`
	},
	':hover:not(.Mui-disabled):before': {
		borderWidth: '1px',
		borderColor: `${WHITE} !important`
	},
	':after': {
		borderWidth: '1px',
		borderColor: `${WHITE} !important`
	}
})

const CustomTextField = (
	{
		id,
		multiline,
		rows,
		maxLength,
		placeholder,
		register,
		inputProps,
		InputProps,
		inputRef,
		label,
		sx,
		errorWhite = false,
		fromDatePicker = false
	}: CustomTextFieldProps
) => {
	const { formState: { errors } } = useFormContext()

	const CUSTOM_STYLE = () => ({
		...sx
	})

	return (
		<>
			{
				label && (
					<span
						style={{
							width: '100%',
							paddingRight: 15,
							paddingTop: 7,
							fontSize: 14,
							marginBottom: 5,
							marginLeft: 0,
							boxSizing: 'border-box',
							textAlign: 'left',
							fontFamily: fontFamilyMonserrat,
							fontWeight: 500
						}}
					>
						{label}
					</span>
				)
			}
			<Input
				{...!fromDatePicker && { ...register }}
				color="primary"
				multiline={multiline}
				rows={rows}
				inputProps={{
					maxLength: maxLength,
					...inputProps
				}}
				inputRef={inputRef}
				startAdornment={InputProps?.startAdornment || undefined}
				sx={[CUSTOM_TEXT_FIELD_STYLE(register, errors), CUSTOM_STYLE()]}
				id={id}
				placeholder={placeholder}
				disableUnderline
				onBlur={() => {
				}}
			/>
			{
				get(errors, register.name) && (
					<ErrorComponent errorWhite={errorWhite}>
						{get(errors, register.name).message}
					</ErrorComponent>
				)
			}
		</>
	)
}

export default CustomTextField
